import { reqZxxxList } from '@/api'

const state = {
  zxxxList: [],
}
const mutations = {
  forZxxxList(state, zxxxList) {
    state.zxxxList = zxxxList
  },
}
const actions = {
  async zxxxList({ commit }) {
    const result = await reqZxxxList()
    if (result.code === 200) {
      commit('forZxxxList', result.data)
    }
  },
}
const getters = {}
export default {
  state,
  mutations,
  actions,
  getters,
}
